module.exports = __webpack_public_path__ + "img/Parin Parikh, Co-Director of Corporate Relations, SFA Club.5a8cc715.webp";